import { useRef } from "react"
import type { RefObject } from "react"

import head from "lodash-es/head"
import { useMount, useUnmount } from "react-use"

function useHtmlScrollbarGutter(options: { isEnabled: boolean }): void {
    const htmlElementRef: RefObject<HTMLElement> = useRef<HTMLElement>(
        head<HTMLElement>(document.getElementsByTagName("html"))
    )

    useMount((): void => {
        if (!options.isEnabled) return

        if (htmlElementRef.current) htmlElementRef.current.setAttribute("class", "[scrollbar-gutter:stable]")
    })

    useUnmount((): void => {
        if (!options.isEnabled) return

        if (htmlElementRef.current) htmlElementRef.current.removeAttribute("class")
    })
}

export { useHtmlScrollbarGutter }
